import {
  CustomFieldExtensionSchema,
  FieldExtensionComponentProps,
} from '@backstage/plugin-scaffolder-react';

import FormControl from '@material-ui/core/FormControl';

import {
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@material-ui/core';

export const EnvironmentExtensionSchema: CustomFieldExtensionSchema = {
  uiOptions: {
    type: 'object',
    required: ['fieldName'],
    properties: {
      fieldName: {
        description:
          'The name of the field use to validate in the accounts API',
        type: 'string',
      },
      formattedHelp: {
        description:
          'Help text containing HTML elements for advanced formatting',
        type: 'string',
      },
    },
  },
  returnValue: { type: 'string' },
};

export const Environment = ({
  onChange,
  required,
  formData,
  uiSchema,
}: FieldExtensionComponentProps<string>) => {
  const fieldName = uiSchema?.['ui:options']?.fieldName as string;
  return (
    <FormControl margin="normal" required={required}>
      <FormLabel htmlFor="environmentRadio">Environment</FormLabel>
      <RadioGroup
        id="environmentRadio"
        value={formData}
        name="environment-radio-group"
        onChange={e => {
          onChange(e?.target.value);
        }}
      >
        <FormControlLabel
          value='["dev", "staging", "prod"]'
          control={<Radio />}
          label="Dev, Staging, and Prod"
        />
        <FormControlLabel
          value='["dev"]'
          control={<Radio />}
          label="Dev Only"
        />
      </RadioGroup>
      {uiSchema?.['ui:options'] !== undefined && (
        <FormHelperText id={`${fieldName}HelperText`}>
          <Typography variant="body1">
            <div
              dangerouslySetInnerHTML={{
                __html: uiSchema['ui:options'].formattedHelp as string,
              }}
            />
          </Typography>
        </FormHelperText>
      )}
    </FormControl>
  );
};
